import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initializeBrowserI18n } from "./i18n";
import { getLanguageFromPath, getRouteDefinition, NOT_FOUND_ROUTE } from "./site-config";

async function bootstrap() {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }

  const pathname = window.location.pathname;
  const language = getLanguageFromPath(pathname);
  const route = getRouteDefinition(pathname);

  const [i18nInstance] = await Promise.all([
    initializeBrowserI18n(language),
    (route?.loader() ?? NOT_FOUND_ROUTE.loader()).catch(() => undefined),
  ]);

  const app = <App initialLanguage={language} i18nInstance={i18nInstance} />;

  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
    return;
  }

  createRoot(rootElement).render(app);
}

void bootstrap();
